import LabelList from './view'

export default LabelList
